export default __webpack_public_path__ + "static/media/eye_of_perception.907a0288.png";